<template>


		<span v-if="$page.props.errors.languages" class="errormessage mr-4">{{ $page.props.errors.languages }}</span>

		<div class="flex flex-wrap">
		    <div class="w-8/12 pr-4">
                <h5 class="text-white text-lg font-bold mb-3">Title</h5>
                <input class="input-black" type="text" v-model="form.title">
                <h5 class="text-white text-lg font-bold mb-3">Description</h5>
                <textarea class="input-black" rows="7" v-model="form.description"></textarea>
            </div>
            <div class="w-4/12">
                <h5 class="text-white text-lg font-bold mb-3">Gallery image</h5>
                <RecommendedAspectRatio uploadBoxType="gallery-image" />
                <span v-if="$page.props.errors" class="errormessage">{{ $page.props.errors.file }}</span>
                <div class="upload-box" v-if="!form.loaded_file_path">
                <span>
                    <i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('gallery_image')">Upload from media library</a>
                </span>
                </div>
                <div v-if="form.loaded_file_path" class="upload-box">
                    <img :src="form.loaded_file_path">
                </div>
            </div>
            <div class="w-full">
                <div class="flex mt-5 justify-center w-100">
                    <button v-if="!form.processing" @click.prevent="saveItem" class="btn btn-sm btn-gradient">+ Add new item</button>
                    <button v-else class="btn btn-sm btn-gradient"><Spinner/></button>
                </div>
            </div>
		</div>


</template>

<script>
import Spinner from '@/UI/Spinner';
import RecommendedAspectRatio from '@/Pages/Media/RecommendedAspectRatio';

export default {
	components: {
		Spinner,
		RecommendedAspectRatio
	},
	props: ['current_language', 'updateGallery', 'changeUploadBoxState', 'form', 'onGalleryItemSubmitted'],
	data(){
		return{
			station_id: this.$page.props.station.data.id,
	      	showMediaModal: false,
		}
	},
	watch:{
    current_language: function (newState, oldState){
        this.form.current_language = newState;
        this.$page.props.errors.file = null;
        this.$page.props.errors.languages = null;
    }
  },
	methods: {
	    saveItem(e){
	    	e.target.disabled = true;
	        e.target.innerHTML = 'Loading...';
	        this.$page.props.errors.file = null;
	        this.form.post(route('station.add-item-to-gallery', this.station_id), {
	          preserveScroll: true,
	          onSuccess: () => {
	          	e.target.disabled = false;
	        	e.target.innerHTML = '+ Save item';
	          	this.updateGallery();
	          	this.resetForm();
	          	this.onGalleryItemSubmitted();
	          },
	          onError: (err) => {
	          	e.target.disabled = false;
	        	e.target.innerHTML = '+ Save item';
	          	this.$page.props.errors.file = err.file;
	          }
	        });
	    },
	    resetForm(){
	    	this.form.title = '';
	    	this.form.description = '';
	    	this.form.file = null;
	    }
	}
}
</script>
